module.exports = __webpack_public_path__ + "static/media/gif.93003b1b.gif";